import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthState } from './auth.state';

export const authGuard = () => {
  const router = inject(Router);
  const token = AuthState.accessToken;

  return !!token() || router.navigate(['/auth/login']);
};
